"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Badge: () => Badge,
  BreakpointFlex: () => BreakpointFlex,
  Button: () => Button_default,
  ButtonGroup: () => ButtonGroup_default,
  DESKTOP_CONTAINER_WIDTH: () => DESKTOP_CONTAINER_WIDTH,
  FabButton: () => FabButton,
  Flex: () => Flex_default,
  HeaderText: () => HeaderText_default,
  JumboText: () => JumboText_default,
  MEDIA_QUERY_LARGE: () => MEDIA_QUERY_LARGE,
  MEDIA_QUERY_MAX: () => MEDIA_QUERY_MAX,
  MEDIA_QUERY_MOBILE: () => MEDIA_QUERY_MOBILE,
  MEDIA_QUERY_XL: () => MEDIA_QUERY_XL,
  MEDIA_QUERY_XXL: () => MEDIA_QUERY_XXL,
  MOBILE_BREAKPOINT: () => MOBILE_BREAKPOINT,
  Paragraph: () => Paragraph_default,
  StepProgress: () => StepProgress,
  Switch: () => Switch_default,
  ThemeProvider: () => ThemeProvider_default,
  Tooltip: () => Tooltip,
  black: () => black,
  columnStyles: () => columnStyles,
  createSwatch: () => createSwatch,
  customQuery: () => customQuery,
  grey: () => grey,
  rowStyles: () => rowStyles,
  useDebounce: () => useDebounce_default,
  useScrollIntoView: () => useScrollIntoView_default,
  white: () => white,
  withRef: () => withRef
});
module.exports = __toCommonJS(src_exports);

// src/components/Button.tsx
var import_react2 = require("react");
var import_styled_components = __toESM(require("styled-components"));
var import_polished3 = require("polished");

// src/providers/ThemeProvider.tsx
var import_react = require("react");
var import_polished2 = require("polished");

// src/utils/colors.ts
var import_polished = require("polished");
var createSwatch = (color) => ({
  light: (0, import_polished.tint)(0.4, color),
  base: color,
  dark: (0, import_polished.shade)(0.4, color)
});
var black = "#000000";
var grey = "#919191";
var white = "#FFFFFF";

// src/providers/ThemeProvider.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var colorWithFallback = (color, fallback) => {
  return color ? color : fallback;
};
var ThemeContext = (0, import_react.createContext)({
  primary: "#8B5FBF",
  secondary: "#643A71",
  tertiary: "#89BBFE",
  primaryButtonText: "#FFFFFF",
  secondaryButtonText: "#FFFFFF",
  tertiaryButtonText: "#FFFFFF",
  accent: "#FEC0CE",
  links: "#DC6ACF",
  light: "#F0EFF4",
  dark: "#1E3231",
  black,
  white,
  grey,
  warning: "#FF3C38",
  success: "#06D6A0"
});
function ThemeProvider({ theme, children }) {
  const processedTheme = (0, import_react.useMemo)(() => {
    const {
      primary,
      secondary,
      tertiary,
      accent,
      links,
      dark,
      light,
      warning,
      success,
      primaryButtonText,
      secondaryButtonText,
      tertiaryButtonText
    } = theme;
    const processedTertiary = tertiary ? tertiary : "#89BBFE";
    return {
      primary,
      secondary,
      tertiary: processedTertiary,
      primaryButtonText: primaryButtonText ? primaryButtonText : (0, import_polished2.readableColor)(primary, black, white),
      secondaryButtonText: secondaryButtonText ? secondaryButtonText : (0, import_polished2.readableColor)(secondary, black, white),
      tertiaryButtonText: tertiaryButtonText ? tertiaryButtonText : (0, import_polished2.readableColor)(processedTertiary, black, white),
      accent: colorWithFallback(accent, "#FEC0CE"),
      links: colorWithFallback(links, "#DC6ACF"),
      dark: colorWithFallback(dark, "#1E3231"),
      light: colorWithFallback(light, "#F0EFF4"),
      warning: colorWithFallback(warning, "#FF3C38"),
      success: colorWithFallback(success, "#06D6A0"),
      black: "#000000",
      white: "#FFFFFF",
      grey
    };
  }, [theme]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(ThemeContext.Provider, { value: processedTheme, children });
}
var ThemeProvider_default = ThemeProvider;
var useTheme = () => (0, import_react.useContext)(ThemeContext);

// src/components/Button.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var Button = (props) => {
  const theme = (0, import_react2.useContext)(ThemeContext);
  const { format = "primary" } = props;
  const themeColor = theme[format];
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(ButtonStyled, __spreadProps(__spreadValues({}, props), { theme, themeColor }));
};
var Button_default = Button;
var FabButton = (props) => {
  const theme = (0, import_react2.useContext)(ThemeContext);
  const { format = "primary" } = props;
  const themeColor = theme[format];
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(FabButtonStyled, __spreadProps(__spreadValues({}, props), { theme, themeColor }));
};
var fabStyles = import_styled_components.css`
  border-radius: 50%;
  width: 40px;
  height: 40px;
  min-width: 0px;
  padding: 0;
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;
`;
var disabledStyles = import_styled_components.css`
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
`;
var getButtonTextTheme = (format) => {
  switch (format) {
    case "primary":
      return "primaryButtonText";
    case "secondary":
      return "secondaryButtonText";
    case "tertiary":
      return "tertiaryButtonText";
    case "light":
      return "dark";
    case "dark":
      return "light";
    default:
      return void 0;
  }
};
var getButtonTextColor = (format, theme) => {
  const textTheme = getButtonTextTheme(format);
  const textColor = textTheme ? theme[textTheme] : (0, import_polished3.readableColor)(theme[format]);
  return textColor;
};
var getBorderStyles = (themeColor, isTransparent) => {
  return import_styled_components.css`
    border-color: ${themeColor};
    &:hover {
      border-color: ${isTransparent ? themeColor : (0, import_polished3.darken)(0.15, themeColor)};
    }
  `;
};
var getSizeBasedStyles = (size = "medium") => {
  switch (size) {
    case "small":
      return import_styled_components.css`
        padding: 8px 10px;
        min-width: 50px;
        font-size: 0.85rem;
      `;
    case "medium":
      return import_styled_components.css`
        padding: 12px 16px;
        min-width: 125px;
        font-size: 1rem;
      `;
    case "large":
      return import_styled_components.css`
        padding: 14px 24px;
        min-width: 175px;
        font-size: 1.15rem;
      `;
  }
};
var getFabSizeBasedStyles = (size = "medium") => {
  switch (size) {
    case "small":
      return import_styled_components.css`
        width: 40px;
        height: 40px;
      `;
    case "medium":
      return import_styled_components.css`
        width: 65px;
        height: 65px;
      `;
    case "large":
      return import_styled_components.css`
        width: 85px;
        height: 85px;
      `;
  }
};
var getHoverColorStyles = ({
  themeColor,
  theme,
  $transparent,
  format
}) => {
  return import_styled_components.css`
    &:hover {
      background-color: ${$transparent ? (0, import_polished3.rgba)(themeColor, 0.2) : (0, import_polished3.darken)(0.15, themeColor)};
      color: ${$transparent ? themeColor : getButtonTextColor(format, theme)};
      i {
        color: inherit;
      }
    }
  `;
};
var ButtonStyled = import_styled_components.default.button.withConfig({ shouldForwardProp: (prop) => prop !== "themeColor" && prop !== "theme" })`
  width: ${(props) => props.fullWidth ? "100%" : "auto"};
  background-color: ${(props) => props.$transparent ? "transparent" : props.themeColor};
  color: ${(props) => props.$transparent ? props.themeColor : getButtonTextColor(props.format, props.theme)};
  ${({ size }) => getSizeBasedStyles(size)};
  outline: none;
  border: ${(props) => props.withBorder ? `solid 2px ${props.themeColor}` : "none"};
  ${(props) => props.withBorder ? getBorderStyles(props.themeColor, props.$transparent) : ""};
  cursor: pointer;
  ${({ uppercase }) => uppercase ? "text-transform: uppercase;" : ""};
  transition: all 0.25s ease-in-out;
  border-radius: 5px;
  ${(props) => props.disabled ? disabledStyles : ""};

  i {
    color: inherit;
  }

  ${({ theme, themeColor, format, $transparent }) => getHoverColorStyles({ theme, themeColor, format, $transparent })}
`;
var FabButtonStyled = import_styled_components.default.button.withConfig({ shouldForwardProp: (prop) => prop !== "themeColor" && prop !== "theme" })`
  ${fabStyles};
  ${({ size }) => getFabSizeBasedStyles(size)};
  outline: none;
  background-color: ${(props) => props.$transparent ? "transparent" : props.themeColor};
  border: ${(props) => props.withBorder ? `solid 2px ${props.themeColor}` : "none"};
  cursor: pointer;
  color: ${(props) => props.$transparent ? props.themeColor : getButtonTextColor(props.format, props.theme)};
  i,
  svg {
    color: inherit;
  }
  svg {
    fill: ${(props) => props.$transparent ? props.themeColor : getButtonTextColor(props.format, props.theme)};
  }
  ${({ theme, themeColor, format, $transparent }) => getHoverColorStyles({ theme, themeColor, format, $transparent })}
`;

// src/components/ButtonGroup.tsx
var import_styled_components2 = __toESM(require("styled-components"));
var import_polished4 = require("polished");
var import_jsx_runtime3 = require("react/jsx-runtime");
var ButtonGroup = ({
  format,
  size,
  $transparent,
  buttons,
  activeColor
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(Container, { className: "bq-btn-group", children: buttons.map((buttonProps, index) => /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    Button_default,
    __spreadProps(__spreadValues({}, buttonProps), {
      format,
      $transparent,
      size,
      style: buttonProps.active && activeColor ? {
        backgroundColor: activeColor,
        color: (0, import_polished4.readableColor)(activeColor)
      } : void 0
    }),
    `button-child-${index}`
  )) });
};
var ButtonGroup_default = ButtonGroup;
var Container = import_styled_components2.default.div`
  display: flex;
  flex-flow: row;

  button {
    min-width: 85px;
  }

  button:first-child {
    border-radius: 0;
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
  }
  button:last-child {
    border-radius: 0;
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
  }

  button:not(:first-child) {
    border-left: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  button:not(:last-child) {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
`;

// src/components/Switch.tsx
var import_polished5 = require("polished");
var import_react3 = require("react");
var import_styled_components4 = __toESM(require("styled-components"));

// src/components/Flex.tsx
var import_styled_components3 = __toESM(require("styled-components"));
var import_jsx_runtime4 = require("react/jsx-runtime");
var defaults = {
  display: "flex"
};
var Flex = (_a) => {
  var _b = _a, {
    children,
    className,
    style
  } = _b, flexProps = __objRest(_b, [
    "children",
    "className",
    "style"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className, style: __spreadValues(__spreadValues(__spreadValues({}, flexProps), defaults), style), children });
};
var Flex_default = Flex;
var BreakpointFlex = (_a) => {
  var _b = _a, {
    children,
    className,
    style
  } = _b, flexProps = __objRest(_b, [
    "children",
    "className",
    "style"
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(StyledFlex, __spreadProps(__spreadValues({ className, style: __spreadValues({}, style) }, flexProps), { children }));
};
var StyledFlex = import_styled_components3.default.div`
  ${(props) => Object.keys(props).map(
  (prop) => `${prop}: ${props[prop]}`
)};
`;
var columnStyles = (justify = "flex-start", align = "flex-start", gap = 0) => import_styled_components3.css`
  display: flex;
  flex-flow: column;
  justify-content: ${justify};
  align-items: ${align};
  gap: ${gap}px;
`;
var rowStyles = (justify = "flex-start", align = "flex", gap = 0) => import_styled_components3.css`
  display: flex;
  flex-flow: row;
  justify-content: ${justify};
  align-items: ${align};
  gap: ${gap}px;
`;

// src/components/Switch.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var Switch = ({
  onChange,
  checked: defaultChecked = false,
  name,
  isSubmitting,
  format = "primary",
  leftLabel,
  rightLabel,
  size = "medium"
}) => {
  console.log("Switch");
  const [checked, setIsChecked] = (0, import_react3.useState)(defaultChecked);
  const theme = (0, import_react3.useContext)(ThemeContext);
  const handleChange = (event) => {
    console.log("getting here", event);
    onChange == null ? void 0 : onChange(event);
    setIsChecked(event.currentTarget.checked);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(Container2, { className: checked ? "on" : "off", children: [
    leftLabel && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("label", { htmlFor: name, children: leftLabel }),
    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      "input",
      {
        type: "checkbox",
        name,
        onChange: handleChange,
        checked,
        id: name,
        disabled: isSubmitting
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
      Toggle,
      {
        className: checked ? "on" : "off",
        disabled: isSubmitting,
        themeColor: theme[format],
        size,
        onClick: () => setIsChecked(!checked)
      }
    ),
    rightLabel && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("label", { htmlFor: name, children: rightLabel })
  ] });
};
var Switch_default = Switch;
var getTrackSizeStyles = (size) => {
  switch (size) {
    case "large":
      return import_styled_components4.css`
        width: 75px;
        height: 36px;
      `;
    case "medium":
      return import_styled_components4.css`
        width: 55px;
        height: 24px;
      `;
    case "small":
      return import_styled_components4.css`
        width: 36px;
        height: 14px;
      `;
    default:
      return ``;
  }
};
var getKnobSizeStyles = (size) => {
  switch (size) {
    case "large":
      return import_styled_components4.css`
        width: 42px;
        height: 42px;
      `;
    case "medium":
      return import_styled_components4.css`
        width: 30px;
        height: 30px;
      `;
    case "small":
      return import_styled_components4.css`
        width: 20px;
        height: 20px;
      `;
    default:
      return ``;
  }
};
var Container2 = import_styled_components4.default.div`
  input {
    visibility: hidden;
    width: 0;
    height: 0;
    /* opacity: 0; */
  }
  ${rowStyles("flex-start", "center")};
`;
var disabledStyles2 = import_styled_components4.css`
  pointer-events: none;
  opacity: 0.75;
`;
var Toggle = import_styled_components4.default.span.withConfig({
  shouldForwardProp: (prop) => !["themeColor"].includes(prop)
})`
  ${({ size }) => getTrackSizeStyles(size)}
  display: block;
  position: relative;
  border-radius: 15px;
  margin-right: 12px;
  background: rgba(0, 0, 0, 0.15);
  cursor: pointer;
  ${(props) => props.disabled && disabledStyles2};
  &:hover {
    background: rgba(0, 0, 0, 0.25);
  }
  &.on {
    background: ${({ themeColor }) => (0, import_polished5.rgba)(themeColor, 0.5)};
  }
  &::after {
    content: " ";
    position: absolute;
    box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
    z-index: 1;
    border-radius: 50%;
    ${({ size }) => getKnobSizeStyles(size)};
    top: -3px;
    left: 0;
    transform: translate3d(100%, 0, 0);
    will-change: transform;
    transition: transform 0.25s ease-in-out;
    background-color: ${({ themeColor }) => themeColor};
  }

  &.off::after {
    transform: translate3d(0, 0, 0);
    background-color: white;
  }
`;

// src/components/Badge.tsx
var import_styled_components5 = __toESM(require("styled-components"));
var import_polished6 = require("polished");
var import_jsx_runtime6 = require("react/jsx-runtime");
function Badge({ children, format, badgeContent }) {
  const theme = useTheme();
  const bgColor = theme[format];
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(Container3, { children: [
    children,
    /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
      BadgeCircle,
      {
        className: "bq-badge",
        style: { backgroundColor: bgColor, color: (0, import_polished6.readableColor)(bgColor) },
        children: badgeContent
      }
    )
  ] });
}
var Container3 = import_styled_components5.default.div`
  position: relative;
  display: inline-flex;
`;
var BadgeCircle = import_styled_components5.default.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: inline-flex;
  ${columnStyles("center", "center")}
  transform: scale(1) translate(50%, -50%);
  transform-origin: 100% 0;
`;

// src/components/Tooltip.tsx
var import_react4 = require("react");
var import_styled_components6 = __toESM(require("styled-components"));
var import_jsx_runtime7 = require("react/jsx-runtime");
function Tooltip({ children, text }) {
  const [showTooltip, setShowTooltip] = (0, import_react4.useState)(false);
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(
    Container4,
    {
      onMouseOver: () => setShowTooltip(true),
      onMouseOut: () => setShowTooltip(false),
      children: [
        children,
        showTooltip && /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(TooltipText, { className: "bq-tooltip", children: text })
      ]
    }
  );
}
var Container4 = import_styled_components6.default.div`
  position: relative;
  display: inline-flex;
`;
var TooltipText = import_styled_components6.default.div`
  position: absolute;
  top: -50%;
  right: 15%;
  z-index: 1;
  border-radius: 8px;
  padding: 8px;
  background-color: rgba(0, 0, 0, 0.4);
  color: rgba(255, 255, 255, 1);
  display: inline-flex;
  ${columnStyles("center", "center")}
  transform: scale(1) translate(50%, -50%);
  transform-origin: 100% 0;
`;

// src/components/StepProgress.tsx
var import_styled_components7 = __toESM(require("styled-components"));
var import_react5 = require("react");
var import_polished7 = require("polished");
var import_jsx_runtime8 = require("react/jsx-runtime");
var getTextAndBackgroundStyles = (current, self, themeColor) => {
  if (current === self) {
    return {
      backgroundColor: themeColor,
      color: (0, import_polished7.readableColor)(themeColor),
      fontWeight: 700
    };
  }
  if (current > self) {
    const color = (0, import_polished7.darken)(0.15, themeColor);
    return {
      backgroundColor: color,
      color: (0, import_polished7.readableColor)(color),
      fontWeight: 600
    };
  }
  return {
    backgroundColor: "#aeaeae",
    color: "#010101"
  };
};
function StepProgress({
  currentStep,
  labels,
  format = "primary",
  onStepSelect
}) {
  const theme = (0, import_react5.useContext)(ThemeContext);
  const themeColor = theme[format];
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Flex_default, { gap: "8px", alignItems: "center", children: labels.map((label, index) => /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Clickable, { onClick: () => onStepSelect == null ? void 0 : onStepSelect(index), children: /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(LabelContainer, { gap: "4px", alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
      Number,
      {
        className: "bq-step-num",
        style: getTextAndBackgroundStyles(currentStep, index, themeColor),
        children: index + 1
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
      "label",
      {
        style: {
          color: currentStep >= index ? themeColor : "inherit"
        },
        children: label
      }
    ),
    index < labels.length - 1 && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
      "div",
      {
        style: {
          width: "50px",
          height: "2px",
          backgroundColor: currentStep >= index ? themeColor : "#aeaeae",
          transition: "all 0.25s ease-in-out"
        }
      }
    )
  ] }) })) });
}
var LabelContainer = (0, import_styled_components7.default)(Flex_default)``;
var Number = import_styled_components7.default.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  ${rowStyles("center", "center")}
`;
var Clickable = import_styled_components7.default.div`
  cursor: pointer;
`;

// src/utils/refs.tsx
var import_react6 = require("react");
var import_jsx_runtime9 = require("react/jsx-runtime");
function withRef(MainComponent) {
  return (0, import_react6.forwardRef)(function ComponentWithRef(props, ref) {
    return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(MainComponent, __spreadProps(__spreadValues({}, props), { ref }));
  });
}

// src/utils/mediaQueries.ts
var DESKTOP_CONTAINER_WIDTH = 960;
var MOBILE_BREAKPOINT = 767;
var MEDIA_QUERY_MAX = "(max-width: 1600px)";
var MEDIA_QUERY_XXL = "(max-width: 1280px)";
var MEDIA_QUERY_XL = "(max-width: 1024px)";
var MEDIA_QUERY_LARGE = "(max-width: 960px)";
var MEDIA_QUERY_MOBILE = "(max-width: 767px)";
var customQuery = (width) => `(max-width: ${width}px)`;

// src/hooks/useDebounce.ts
var import_react7 = require("react");
function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = (0, import_react7.useState)(value);
  (0, import_react7.useEffect)(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}
var useDebounce_default = useDebounce;

// src/hooks/useScrollIntoView.ts
var import_react8 = require("react");
function useScrollIntoView(threshold = 1, rootMargin, onView) {
  const ref = (0, import_react8.useRef)(null);
  const [isInView, setInView] = (0, import_react8.useState)(false);
  const handleInView = (0, import_react8.useCallback)(
    (entry) => {
      if (entry[0].isIntersecting && !isInView) {
        if (onView) {
          onView();
        }
        setInView(true);
      }
    },
    [onView, isInView]
  );
  (0, import_react8.useEffect)(() => {
    const observer = new IntersectionObserver(handleInView, {
      root: null,
      threshold,
      rootMargin
    });
    if (ref.current)
      observer.observe(ref.current);
    return () => {
      if (ref.current)
        observer.unobserve(ref.current);
    };
  }, []);
  return { isInView, ref };
}
var useScrollIntoView_default = useScrollIntoView;

// src/typography/HeaderText.tsx
var import_react9 = require("react");
var import_styled_components9 = __toESM(require("styled-components"));

// src/typography/config.ts
var import_styled_components8 = require("styled-components");
var getFontWeight = (weight, variableFont) => {
  if (variableFont) {
    return weight ? import_styled_components8.css`
          font-variation-settings: "wght" ${weight};
        ` : "";
  }
  return weight ? import_styled_components8.css`
        font-weight: ${weight};
      ` : "";
};

// src/typography/HeaderText.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");
var HeaderText = (0, import_react9.forwardRef)(function HeaderText2(_a, ref) {
  var _b = _a, { type, children, format, weight, id, className, variable } = _b, htmlProps = __objRest(_b, ["type", "children", "format", "weight", "id", "className", "variable"]);
  const theme = (0, import_react9.useContext)(ThemeContext);
  const themeColor = format === "light" ? theme.light : theme.dark;
  const h3Color = format === "light" ? theme.white : theme.dark;
  const h6Color = format === "light" ? theme.white : theme.dark;
  switch (type) {
    case 1:
      return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        Header1,
        __spreadProps(__spreadValues({
          themeColor,
          weight,
          id,
          className,
          ref,
          variable
        }, htmlProps), {
          children
        })
      );
    case 2:
      return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        Header2,
        __spreadProps(__spreadValues({
          themeColor,
          weight,
          id,
          className,
          ref,
          variable
        }, htmlProps), {
          children
        })
      );
    case 3:
      return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        Header3,
        __spreadProps(__spreadValues({
          themeColor: h3Color,
          weight,
          id,
          className,
          ref,
          variable
        }, htmlProps), {
          children
        })
      );
    case 4:
      return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        Header4,
        __spreadProps(__spreadValues({
          themeColor: h3Color,
          weight,
          id,
          className,
          ref,
          variable
        }, htmlProps), {
          children
        })
      );
    case 5:
      return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        Header5,
        __spreadProps(__spreadValues({
          themeColor: h3Color,
          weight,
          id,
          className,
          ref,
          variable
        }, htmlProps), {
          children
        })
      );
    case 6:
    default:
      return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
        Header6,
        __spreadProps(__spreadValues({
          themeColor: h6Color,
          weight,
          id,
          className,
          ref,
          variable
        }, htmlProps), {
          children
        })
      );
  }
});
var HeaderText_default = HeaderText;
var Header1 = import_styled_components9.default.h1.withConfig({
  shouldForwardProp: (prop) => !["themeColor", "weight", "variables"].includes(prop)
})`
  color: ${(props) => props.themeColor};
  ${({ weight, variable }) => getFontWeight(weight, variable)};
`;
var Header2 = import_styled_components9.default.h2.withConfig({
  shouldForwardProp: (prop) => !["themeColor", "weight", "variables"].includes(prop)
})`
  color: ${(props) => props.themeColor};
  ${({ weight, variable }) => getFontWeight(weight, variable)};
`;
var Header3 = import_styled_components9.default.h3.withConfig({
  shouldForwardProp: (prop) => !["themeColor", "weight", "variables"].includes(prop)
})`
  color: ${(props) => props.themeColor};
  ${({ weight, variable }) => getFontWeight(weight, variable)};
`;
var Header4 = import_styled_components9.default.h4.withConfig({
  shouldForwardProp: (prop) => !["themeColor", "weight", "variables"].includes(prop)
})`
  color: ${(props) => props.themeColor};
  ${({ weight, variable }) => getFontWeight(weight, variable)};
`;
var Header5 = import_styled_components9.default.h5.withConfig({
  shouldForwardProp: (prop) => !["themeColor", "weight", "variables"].includes(prop)
})`
  color: ${(props) => props.themeColor};
  ${({ weight, variable }) => getFontWeight(weight, variable)};
`;
var Header6 = import_styled_components9.default.h6.withConfig({
  shouldForwardProp: (prop) => !["themeColor", "weight", "variables"].includes(prop)
})`
  color: ${(props) => props.themeColor};
  ${({ weight, variable }) => getFontWeight(weight, variable)};
`;

// src/typography/Paragraph.tsx
var import_react10 = require("react");
var import_styled_components10 = __toESM(require("styled-components"));
var import_jsx_runtime11 = require("react/jsx-runtime");
var Paragraph = (0, import_react10.forwardRef)(
  (_a, ref) => {
    var _b = _a, { children, format, weight, className, id } = _b, htmlProps = __objRest(_b, ["children", "format", "weight", "className", "id"]);
    const theme = (0, import_react10.useContext)(ThemeContext);
    const themeColor = format === "light" ? theme.white : theme.dark;
    return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
      ParagraphStyled,
      __spreadProps(__spreadValues({
        themeColor,
        weight,
        className,
        id,
        ref
      }, htmlProps), {
        children
      })
    );
  }
);
var Paragraph_default = Paragraph;
var ParagraphStyled = import_styled_components10.default.p.withConfig({
  shouldForwardProp(prop) {
    return !["themeColor", "weight", "variables"].includes(prop);
  }
})`
  color: ${(props) => props.themeColor};
  ${({ weight, variable }) => getFontWeight(weight, variable)};
`;

// src/typography/JumboText.tsx
var import_react11 = require("react");
var import_styled_components11 = __toESM(require("styled-components"));
var import_jsx_runtime12 = require("react/jsx-runtime");
var JumboText = (0, import_react11.forwardRef)(
  (_a, ref) => {
    var _b = _a, { children, format, weight, className, id } = _b, htmlProps = __objRest(_b, ["children", "format", "weight", "className", "id"]);
    const theme = (0, import_react11.useContext)(ThemeContext);
    const themeColor = format === "light" ? theme.light : theme.dark;
    return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
      Jumbo,
      __spreadProps(__spreadValues({
        themeColor,
        weight,
        className,
        id,
        ref
      }, htmlProps), {
        children
      })
    );
  }
);
var JumboText_default = JumboText;
var Jumbo = import_styled_components11.default.h1.withConfig({
  shouldForwardProp: (prop) => !["themeColor", "weight", "variables"].includes(prop)
})`
  font-size: 3.5rem;
  font-weight: 700;
  color: ${(props) => props.themeColor};
  ${({ weight, variable }) => getFontWeight(weight, variable)};
`;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Badge,
  BreakpointFlex,
  Button,
  ButtonGroup,
  DESKTOP_CONTAINER_WIDTH,
  FabButton,
  Flex,
  HeaderText,
  JumboText,
  MEDIA_QUERY_LARGE,
  MEDIA_QUERY_MAX,
  MEDIA_QUERY_MOBILE,
  MEDIA_QUERY_XL,
  MEDIA_QUERY_XXL,
  MOBILE_BREAKPOINT,
  Paragraph,
  StepProgress,
  Switch,
  ThemeProvider,
  Tooltip,
  black,
  columnStyles,
  createSwatch,
  customQuery,
  grey,
  rowStyles,
  useDebounce,
  useScrollIntoView,
  white,
  withRef
});
